const participantMissionImagesLimit = 5

module.exports = participantMissionImagesLimit